<template>
  <!-- 顶部引流播报条：近10分钟圈子有新内容才显示，点击跳转圈子定位到该动态 -->
  <div v-if="items.length" class="circle-marquee">
    <div class="marquee-label">🔥 圈子新动态</div>
    <div class="marquee-viewport">
      <div class="marquee-track" :style="{ animationDuration: duration + 's' }">
        <span
          v-for="(it, i) in doubledItems"
          :key="i"
          class="marquee-item"
          @click="goPost(it)"
        >
          <b>{{ it.author_name || '匿名律师' }}</b>
          刚刚发布：{{ snippet(it.content) }}
          <i>{{ ago(it.create_time) }}</i>
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { listRecentCirclePost } from '@/api/modules/circle'

const router = useRouter()
const items = ref([])
let timer = null

// 内容复制一份实现无缝循环滚动
const doubledItems = computed(() => items.value.concat(items.value))
// 条数越多滚动越慢，保证可读性
const duration = computed(() => Math.max(18, items.value.length * 8))

async function loadRecent() {
  try {
    const data = await listRecentCirclePost({})
    items.value = data.list || []
  } catch (e) {
    // 静默失败，不打扰用户
  }
}

function snippet(content) {
  const s = String(content || '').replace(/\s+/g, ' ').trim()
  return s.length > 40 ? s.slice(0, 40) + '…' : s
}

function ago(time) {
  const t = new Date(String(time).replace(/-/g, '/')).getTime()
  if (Number.isNaN(t)) return ''
  const m = Math.floor((Date.now() - t) / 60000)
  if (m < 1) return '刚刚'
  return m + '分钟前'
}

function goPost(it) {
  router.push({ path: '/circle/lawyer-circle', query: { post_id: it.post_id, t: Date.now() } })
}

onMounted(() => {
  loadRecent()
  timer = setInterval(loadRecent, 60 * 1000)
})
onUnmounted(() => {
  if (timer) clearInterval(timer)
})
</script>

<style scoped>
.circle-marquee {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 36px;
  padding: 0 16px;
  background: linear-gradient(90deg, #fff7ed, #fef2f2);
  border-bottom: 1px solid #fed7aa;
  overflow: hidden;
}
.marquee-label {
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 700;
  color: #c2410c;
  background: #ffedd5;
  border: 1px solid #fdba74;
  border-radius: 12px;
  padding: 2px 10px;
}
.marquee-viewport {
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
}
.marquee-track {
  display: inline-block;
  white-space: nowrap;
  animation: marquee-scroll linear infinite;
}
.marquee-track:hover {
  animation-play-state: paused;
}
@keyframes marquee-scroll {
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
}
.marquee-item {
  display: inline-block;
  margin-right: 56px;
  font-size: 13px;
  color: #7c2d12;
  cursor: pointer;
}
.marquee-item:hover {
  color: #ea580c;
  text-decoration: underline;
}
.marquee-item b {
  color: #ea580c;
}
.marquee-item i {
  font-style: normal;
  margin-left: 6px;
  font-size: 12px;
  color: #9a3412;
  opacity: 0.7;
}
</style>
